import React from 'react';
import {Navigate} from 'react-router-dom';
import {useApolloClient} from '@apollo/client/react';

import LocalStorageService from '../../services/LocalStorageService';

const Logout = () => {
  const client = useApolloClient();

  LocalStorageService.clearTokens();
  void client.clearStore();

  return <Navigate to="/login" replace />;
};

export default Logout;
